import { createSlice } from '@reduxjs/toolkit';
import { LocalStorage } from '../../shared/utils';

const promoBlockSlice = createSlice({
  name: 'promoBlock',
  initialState: {
    isSearchPromoBlockHidden: LocalStorage.get('isSearchPromoBlockHidden'),
    isWebsitesTreePromoBlockHidden: LocalStorage.get('isWebsitesTreePromoBlockHidden'),
    isWebsitesSettingsPromoBlockHidden: LocalStorage.get('isWebsitesSettingsPromoBlockHidden'),
  },
  reducers: {
    setSearchPromoBlockHidden(state, { payload }) {
      state.isSearchPromoBlockHidden = payload;
      LocalStorage.set('isSearchPromoBlockHidden', payload);
    },
    setWebsitesTreePromoBlockHidden(state, { payload }) {
      state.isWebsitesTreePromoBlockHidden = payload;
      LocalStorage.set('isWebsitesTreePromoBlockHidden', payload);
    },
    setWebsitesSettingsPromoBlockHidden(state, { payload }) {
      state.isWebsitesSettingsPromoBlockHidden = payload;
      LocalStorage.set('isWebsitesSettingsPromoBlockHidden', payload);
    },
  },
});

export const { setWebsitesSettingsPromoBlockHidden, setSearchPromoBlockHidden, setWebsitesTreePromoBlockHidden } = promoBlockSlice.actions;

export default promoBlockSlice.reducer;
